import axios from "axios";
import React, { useState, useEffect } from "react";
import DisplayRow from "../../Components/QueueRow/DisplayRow";
import "./Queue.css";
import AdminNav from "../../Components/AdminNav.jsx/AdminNav";
import { queue } from "jquery";

const Orders = () => {
  const  [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  // let x = axios.get("/ticket");
  useEffect(() => {
    initializeOrders();
    setInterval(() => {
    checkMenu()
    }, 10000);
    // eslint-disable-next-line
  }, []);

  const orderQueue = (list) => {
    let queue = list;
    queue.sort(function(a, b){
      return (a.data.created < b.data.created) ? -1 : ((a.data.created > b.data.created) ? 1 : 0)
  })
     setOrders(queue);
     setLoading(false);
  }


  const checkMenu = async () => {
    try {
      const response = await axios.get("/ticket");
     if (response.data.length !== queue.length) {
      orderQueue(response.data)
     } else {
      setLoading(false);
     }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const initializeOrders = async () => {
    try {
      const response = await axios.get("/ticket");
     orderQueue(response.data)
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  if(loading)return null;

  return (
    <>
      <div className="order-wrapper">
        <table className="left">
          <thead>
            <tr>
              <th className="table-col">Name</th>
              <th className="table-col">Service</th>
              <th className="table-col">Check-in</th>
              <th className="table-col">Elasped</th>
            </tr>
          </thead>
        </table>
        {orders.map((orderItems) => {
          return (
            <React.Fragment>
              <DisplayRow orderItems={orderItems} />
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default Orders;
